import React from 'react'

import Donations from './Donations'

const Top = ({ topOrders, organizer, logged_in, flpSigninPath }) =>
  <>
    <Donations
      orders={topOrders}
      organizer={organizer}
      logged_in={logged_in}
      flpSigninPath={flpSigninPath}
    />
    {
      topOrders.length == 10 &&
      <div className="border-top fst-italic px-3 px-sm-4 py-2">
        <small>*Displaying the top ten donations</small>
      </div>
    }
  </>

export default Top
